// The signed-in session, shared by the screens:
// me = { email, role: "client" | "admin", engagements: [{ slug, name }] }.
// The role only picks which screen to show; the server enforces it.
import { createContext, useContext } from "react";

export const Session = createContext({ me: null, signOut: () => {} });
export const useSession = () => useContext(Session);
